import { useState, useEffect } from 'react'
import { decrypt, generateBrowserFingerprint } from '../../Login/JWTverify'

/**
 * useGoogleAccount
 * -------------------------------------------------
 * Decrypts the stored userJWT and exposes the signed-in Google
 * account details rendered in the header profile button.
 */
export default function useGoogleAccount() {
    const [googleUserData, setGoogleUserData] = useState({})
    const [imageError, setImageError] = useState(false)

    const getDataFromLocalStorage = () => {
        return new Promise((resolve) => {
            let userAccount = localStorage.getItem('userJWT')
            if (userAccount) {
                resolve(userAccount ?? null)
            }
        })
    }

    useEffect(async () => {
        const visitorId = await generateBrowserFingerprint()
        const userJWT = await getDataFromLocalStorage()
        if (!userJWT) return
        const verify = await decrypt(userJWT, visitorId)
        if (verify) {
            setGoogleUserData({
                userAccount_email: verify.email,
                userAccount_name: verify.name,
                userAccount_Img: verify.image,
            })
        }
    }, [])

    return { googleUserData, imageError, setImageError }
}
